module.exports = __webpack_public_path__ + "static/media/smss.2a03c8bf.svg";